import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

export const videoSubmissionList = (params = '') => Http.get(`/admin/video-submissions${serialize(params)}`)

// Same endpoint as videoSubmissionList, but for callers that need `filter[status]`
// as a whereIn (array) — VideoSubmissionRepository::search() already supports it
// server-side. This repo's `serialize()` above is a flat string builder that
// can't encode arrays (see candidates.service.js for the same limitation
// elsewhere), so this bypasses it and lets axios's own query serializer turn an
// array value into repeated `key[]=value` pairs instead.
export const videoSubmissionSearch = (params = {}) => Http.get('/admin/video-submissions', { params })

export const videoSubmissionByID = (params = '') => Http.get(`/admin/video-submissions/${params}`)
export const videoSubmissionApprove = (id, data = {}) => Http.post(`/admin/video-submissions/${id}/approve`, data)
export const videoSubmissionRetry = (id) => Http.post(`/admin/video-submissions/${id}/retry`)
export const videoSubmissionReject = (id, data = {}) => Http.post(`/admin/video-submissions/${id}/reject`, data)

// Books the publication slot. The studio is emailed the date the moment this
// succeeds, which is why the API refuses anything in the past.
export const videoSubmissionSchedule = (id, data = {}) => Http.post(`/admin/video-submissions/${id}/schedule`, data)

// Reviewer-side thumbnail artwork. `cover` is a data URL straight from the
// cropper (canvas.toDataURL()), already framed to 16:9 — which is why the API
// does not re-check the ratio the way it does for a studio's own upload.
export const videoSubmissionSetCover = (id, cover) => Http.post(`/admin/video-submissions/${id}/cover`, { cover })
export const videoSubmissionDeleteCover = id => Http.delete(`/admin/video-submissions/${id}/cover`)
